import { Component, Input, OnInit } from "@angular/core";
import { CryptoWallet } from "@models";
import { WalletService } from "@main-services/wallet/wallet.service";
import { Subscription } from "rxjs";
import { CryptoWalletService } from "@main-services/wallet/crypto_wallet.service";
import { CryptoTransaction } from "@models/transaction";
import { CustomModal } from "@modules/core/components/base-modals";
import { SendTrackingFacade } from "@modules/main/components/step-summary/sending-modal/services/send-tracking.facade";

@Component({
	selector: "send-waiting",
	templateUrl: "./send-waiting.component.html",
	styleUrls: ["./../success-screen.component.scss", "./send-waiting.component.scss"],
	standalone: false
})
export class SendWaitingComponent extends CustomModal implements OnInit {
	@Input()
	public transaction: CryptoTransaction;

	@Input()
	public subForCancel: Subscription = null;

	@Input() isMultichain: boolean = false;
	@Input() cryptoName: string = "";
	@Input() networkName: string = "";

	public constructor(
		private cryptoWalletService: CryptoWalletService,
		private trackingFacade: SendTrackingFacade
	) {
		super();
	}

	ngOnInit(): void {
		this.trackingFacade.trackEmailConfirmationScreenViewed();
	}

	public close(): void {
		this.modalService.pop();
	}

	public cancel(): void {
		if (this.subForCancel) {
			this.subForCancel.unsubscribe();
		}
		this.service.cancel(this.transaction).then(() => this.close());
	}

	public resendEmail(): void {
		this.service.resendEmail(this.transaction);
	}

	public get service(): WalletService<CryptoWallet, CryptoTransaction> {
		return this.cryptoWalletService;
	}
}
